import React from 'react';

const NotFoundPage = () => {
  return (
    <div className='error-page'>
      <div className='error-emoji'>😕</div>
      <p className='error-text'>Oops! Error - 404 Page Not Found</p>
      <a href="/" className='error-link'>Go Back Home</a>
    </div>
  );
};
 
export default NotFoundPage;